import { notify } from '@/common/index.js';
import { http } from '@/common/api';

import {
  STATUS_CODE_SUCCESS,
  UN_PUBLIC_FLAG,
  LANG_CODE_VIETNAMESE,
  CHECKIN_SUCCESS_MESSAGE_VI,
  CHECKIN_SUCCESS_MESSAGE_JP_EN,
  CHECKED_IN,
  CHECKED_IN_COMPANY_MESSAGE_VI,
  CHECKED_IN_COMPANY_MESSAGE_JP_EN,
  NOT_EXIST_COMPANY_MESSAGE_VI,
  NOT_EXIST_COMPANY_MESSAGE_JP_EN,
  CHECKED_IN_RECEPTIONIST_MESSAGE_VI,
  CHECKED_IN_RECEPTIONIST_MESSAGE_JP_EN,
  NOT_EXIST_RECEPTIONIST_MESSAGE_VI,
  NOT_EXIST_RECEPTIONIST_MESSAGE_JP_EN,
  NOT_CHECKED_IN_EVENT,
  NOT_CHECKED_IN_EVENT_MESSAGE_VI,
  NOT_CHECKED_IN_EVENT_MESSAGE_JP_EN,
  INVALID_CHECK_IN,
  TIME_ERROR_CHECK_IN,
  TIME_ERROR_CHECK_IN_MESSAGE_VN,
  TIME_ERROR_CHECK_IN_MESSAGE_JP_EN
  // ENTRY_ENDPOINT_NAME,
  // RECEPTIONIST_ENDPOINT_NAME
} from '@/common/constants';

import {
  EVENT_SUCCESS,
  EVENT_ERROR,
  GET_LANG,
  CHANGE_LANGUAGE,
  GET_CONSTANTS,
  GET_EVENT_MASTER,
  STEP_ONE_STORAGE,
  STEP_TWO_STORAGE,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LANDING_PAGE_LINK_SUCCESS,
  LOGIN_SUCCESS_RECEPTIONIST,
  LOGIN_ERROR_RECEPTIONIST,
  REGISTER_SUCCESS,
  REGISTER_ERROR,
  SET_AUTHENTICATED,
  LOGOUT,
  LOGOUT_RECEPTIONIST,
  GET_LIST_COMPANY,
  ACTION_TO_FAVORITE,
  COMPANY_DETAIL,
  PREVIEW_COMPANY_SUCCESS,
  PREVIEW_COMPANY_ERROR,
  ME_SUCCESS,
  ME_ERROR,
  UPDATE_INFORMATION_SUCCESS,
  UPDATE_ENTRY_INFORMATION_SUCCESS,
  CHECK_AUTHENTICATED,
  CHECK_UNAUTHORIZED,
  CONFIRM_MAIL_ERROR,
  UPDATE_SCOUT_MAIL_VIEWED_SUCCESS,
  UPDATE_READ_FLAG_NOTIFICATION_APPLICANT_SUCCESS,
  UPDATE_DISPLAY_FLAG_NOTIFICATION_APPLICANT_SUCCESS,
  UPDATE_READ_FLAG_INFO_LOG_SUCCESS,
  UPDATE_DISPLAY_FLAG_INFO_LOG_SUCCESS,
  CONFIRM_MAIL_ERROR_RESET,
  CONFIRM_MAIL_SUCCESS,
  SET_DOMAIN,
  RESET_REGISTER_STATUS,
  APPLICANT_COMPANY_INTERVIEW,
  CLEAR_REGISTER_DATA,
  APPLICANT_INTERVIEW_STATUS,
  SET_TOKEN_FOR_RECEPTIONIST,
  EVENT_INTERVIEW_NOTE,
  // ME_SUCCESS_RECEPTIONIST,
  // ME_ERROR_RECEPTIONIST,
  CHECK_IN_SUCCESS,
  CHECK_IN_ERROR,
  LIST_CHECK_IN_SUCCESS,
  LIST_CHECK_IN_ERROR,
  SET_CONTRACT_EVENT,
  CHECK_UNAUTHORIZED_RECEPTIONIST,
  SET_REGISTRATION_PERIOD_STATUS,
  GET_DATA_EVENT_SCHEDULE_SUCCESS,
  SET_EVENT_SCHEDULE_SUCCESS,
  CLEAR_CHECK_IN_DATA
} from './mutation-types';

import router from '@/plugins/router';

import url from '@/constants/api-url.js';

const actions = {
  getConstants: async ({ commit, state }) => {
    try {
      const res = await http(state, false).get(`${url.GET_CONSTANT}`);

      await commit(GET_LANG);
      await commit(GET_CONSTANTS, { data: res.data.data });
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  getEventMaster: async ({ commit, state }, { data, fullPath }) => {
    try {
      const res = await http(state, false).post(`${url.EVENT_MASTER}`, data);
      if (res.data.status === STATUS_CODE_SUCCESS) {
        await commit(GET_LANG);
        await commit(GET_EVENT_MASTER, {
          data: res.data.data,
          registrationPeriodStatus: res.data.registrationPeriodStatus
        });
        if (
          res.data.data !== null &&
          typeof res.data.data.m_event !== 'undefined'
        ) {
          const { publicize_flag } = res.data.data.m_event;
          if (publicize_flag === UN_PUBLIC_FLAG) {
            await commit(EVENT_ERROR);
          } else {
            const params = new URLSearchParams(window.location.search);
            const queryLang = params.has('lang') ? params.get('lang') : null;

            await commit(EVENT_SUCCESS, {
              data,
              fullPath,
              registerStatus: res.data.registrationPeriodStatus,
              queryLang: queryLang
            });

            await commit(CHECK_AUTHENTICATED);
          }
        }
      } else {
        await commit(EVENT_ERROR);
      }
    } catch (err) {
      await commit(EVENT_ERROR);
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  login: async ({ commit, state }, { data }) => {
    try {
      const res = await http(state, false).post(`${url.CANDIDATE_LOGIN}`, data);
      if (res.data.status === STATUS_CODE_SUCCESS) {
        notify('success', 'Message', res.data.message);
        await commit(LOGIN_SUCCESS, {
          token: res.data.token,
          profile: res.data.profile
        });
        return true;
      } else {
        notify('error', 'Message', res.data.message);
        await commit(LOGIN_ERROR);
        return false;
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  checkEmailExisted: async ({ commit, state }, data) => {
    try {
      const res = await http(state, false).post(
        `${url.CANDIDATE_CHECK_EMAIL}`,
        data
      );
      return res.data.status;
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  register: async ({ commit, state }, { data }) => {
    try {
      const res = await http(state, false).post(
        `${url.CANDIDATE_REGISTER}`,
        data
      );
      if (res.data.status === STATUS_CODE_SUCCESS) {
        notify('success', 'Message', res.data.message);
        await commit(REGISTER_SUCCESS, { data: res.data.data });
      } else {
        notify('error', 'Message', res.data.message);
        await commit(REGISTER_ERROR);
      }
    } catch (err) {
      commit(REGISTER_ERROR);
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  resetRegisterStatus: ({ commit }) => {
    commit(RESET_REGISTER_STATUS);
  },

  confirmMailRegister: async ({ commit, state }, { token }) => {
    try {
      const res = await http(state, false).get(
        `${url.CANDIDATE_CONFIRM_MAIL}/${token}`
      );

      if (res.data.status === STATUS_CODE_SUCCESS) {
        notify('success', 'Message', res.data.message);
        await commit(CONFIRM_MAIL_SUCCESS, { data: res.data.data });
      } else {
        notify('error', 'Message', res.data.message);
        await commit(CONFIRM_MAIL_ERROR);
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  confirmMailResetState: ({ commit }) => {
    commit(CONFIRM_MAIL_ERROR_RESET);
  },

  setAuthenticated: async ({ commit }) => {
    await commit(SET_AUTHENTICATED);
  },

  logout: async ({ commit }) => {
    await commit(LOGOUT);

    notify('success', 'Message', 'Logout successfully');
  },

  changeLanguage: ({ commit }, { lang, langTitle = '' }) => {
    commit(CHANGE_LANGUAGE, { lang, langTitle });
  },

  storageStepOne: ({ commit }, { data }) => {
    commit(STEP_ONE_STORAGE, { data });
  },

  storageStepTwo: ({ commit }, { data }) => {
    commit(STEP_TWO_STORAGE, { data });
  },

  getCompanies: async ({ commit, state }) => {
    try {
      const res = await http(state).get(`${url.COMPANY_LIST_COMPANY}`);
      if (res.data.status === STATUS_CODE_SUCCESS) {
        commit(GET_LIST_COMPANY, { data: res.data });
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  actionToFavorite: async ({ commit, state }, { exhibiting_company_id }) => {
    try {
      const res = await http(state).post(
        `${url.COMPANY_ACTION_FAVORITE_COMPANY}`,
        {
          exhibiting_company_id
        }
      );
      if (res.data.status === STATUS_CODE_SUCCESS) {
        commit(ACTION_TO_FAVORITE, { data: res.data.data });
        notify('success', 'Message', res.data.message);
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  companyDetail: async ({ commit, state }, { exhibiting_company_id }) => {
    try {
      const res = await http(state).post(`${url.COMPANY_INFO_COMPANY}`, {
        exhibiting_company_id
      });
      if (res.data.status === STATUS_CODE_SUCCESS) {
        commit(COMPANY_DETAIL, { data: res.data.data });
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  previewCompany: async ({ commit, state }, { company_token }) => {
    try {
      const res = await http(state, false).post(`${url.COMPANY_INFO_COMPANY}`, {
        company_token
      });

      if (res.data.status === STATUS_CODE_SUCCESS) {
        commit(COMPANY_DETAIL, { data: res.data.data });
        commit(PREVIEW_COMPANY_SUCCESS);
      } else {
        commit(PREVIEW_COMPANY_ERROR);
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  me: async ({ commit, state }) => {
    try {
      const res = await http(state, true, 'applicant').post(
        `${url.CANDIDATE_ME}`
      );

      if (res.data.status === STATUS_CODE_SUCCESS) {
        commit(ME_SUCCESS, { data: res.data.data });
      } else {
        commit(ME_ERROR);
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  updateBasicInformation: async ({ commit, state }, { data }) => {
    try {
      const res = await http(state).put(
        `${url.CANDIDATE_UPDATE_APPLICANT_INFO}`,
        data
      );
      if (res.data.status === STATUS_CODE_SUCCESS) {
        notify('success', 'Message', 'Update Successful');
        commit(UPDATE_INFORMATION_SUCCESS, {
          data: res.data.data
        });
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  updateEntryInformation: async ({ commit, state }, { data }) => {
    try {
      const res = await http(state).put(
        `${url.CANDIDATE_UPDATE_APPLICANT_ENTRY}`,
        data
      );
      if (res.data.status === STATUS_CODE_SUCCESS) {
        notify('success', 'Message', 'Update Successful');
        commit(UPDATE_ENTRY_INFORMATION_SUCCESS, {
          data: res.data.data
        });
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  updateScoutMailWhenViewed: async ({ commit, state }, data) => {
    try {
      const res = await http(state).post(
        `${url.CANDIDATE_UPDATE_SCOUT_MAIL}`,
        data
      );
      if (res.data.status === STATUS_CODE_SUCCESS) {
        commit(UPDATE_SCOUT_MAIL_VIEWED_SUCCESS, {
          data: res.data.data
        });
      } else {
        notify('error', 'Message', res.data.message);
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  updateReadFlagNotificationApplicant: async ({ commit, state }, data) => {
    try {
      const res = await http(state).post(
        `${url.CANDIDATE_UPDATE_READ_FLAG_NOTIFICATION}`,
        data
      );
      if (res.data.status === STATUS_CODE_SUCCESS) {
        commit(UPDATE_READ_FLAG_NOTIFICATION_APPLICANT_SUCCESS, {
          data: res.data.data
        });
      } else {
        notify('error', 'Message', res.data.message);
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  updateDisplayFlagNotificationApplicant: async ({ commit, state }, data) => {
    try {
      const res = await http(state).post(
        `${url.CANDIDATE_UPDATE_DISPLAY_FLAG_NOTIFICATION}`,
        data
      );
      if (res.data.status === STATUS_CODE_SUCCESS) {
        commit(UPDATE_DISPLAY_FLAG_NOTIFICATION_APPLICANT_SUCCESS, {
          data: res.data.data
        });
      } else {
        notify('error', 'Message', res.data.message);
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  updateReadFlagInfoLogApplicant: async ({ commit, state }, data) => {
    try {
      const res = await http(state).post(
        `${url.CANDIDATE_UPDATE_READ_FLAG_INFO_LOG_APPLICANT}`,
        data
      );
      if (res.data.status === STATUS_CODE_SUCCESS) {
        commit(UPDATE_READ_FLAG_INFO_LOG_SUCCESS, {
          data: res.data.data
        });
      } else {
        notify('error', 'Message', res.data.message);
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  updateDisplayFlagInfoLogApplicant: async ({ commit, state }, data) => {
    try {
      const res = await http(state).post(
        `${url.CANDIDATE_UPDATE_DISPLAY_FLAG_INFO_LOG_APPLICANT}`,
        data
      );
      if (res.data.status === STATUS_CODE_SUCCESS) {
        commit(UPDATE_DISPLAY_FLAG_INFO_LOG_SUCCESS, { data: res.data.data });
      } else {
        notify('error', 'Message', res.data.message);
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  postApplicantLog: async ({ commit, state }, { data }) => {
    try {
      const res = await http(state).post(`${url.LOG}`, data);
      if (res.data.status === STATUS_CODE_SUCCESS) {
        return true;
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  setDomain: async ({ commit }, { data }) => {
    commit(SET_DOMAIN, { host: data.host, protocol: data.protocol });
  },

  applicantCompanyInterview: async (
    { commit, state },
    { exhibiting_company_id }
  ) => {
    try {
      const res = await http(state).post(
        `${url.CANDIDATE_INTERVIEW_SCHEDULE}`,
        {
          exhibiting_company_id
        }
      );
      if (res.data.status === STATUS_CODE_SUCCESS) {
        commit(APPLICANT_COMPANY_INTERVIEW, { data: res.data.data });
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },
  entryCheckInCompany: async ({ commit, state }, data) => {
    try {
      const res = await http(state, true, 'applicant').post(
        `${url.COMPANY_CHECK_IN}`,
        data
      );
      if (res.data.status === STATUS_CODE_SUCCESS) {
        if (state.lang === LANG_CODE_VIETNAMESE) {
          notify('success', 'Message', CHECKIN_SUCCESS_MESSAGE_VI);
        } else {
          notify('success', 'Message', CHECKIN_SUCCESS_MESSAGE_JP_EN);
        }
        if (res.data.data) {
          return res.data.data;
        }
        // await commit(CHECK_IN_SUCCESS, { data: res.data.data });
      } else {
        if (res.data.message === CHECKED_IN) {
          if (state.lang === LANG_CODE_VIETNAMESE) {
            notify('error', 'Message', CHECKED_IN_COMPANY_MESSAGE_VI);
          } else {
            notify('error', 'Message', CHECKED_IN_COMPANY_MESSAGE_JP_EN);
          }
        } else if (res.data.message === NOT_CHECKED_IN_EVENT) {
          if (state.lang === LANG_CODE_VIETNAMESE) {
            notify('error', 'Message', NOT_CHECKED_IN_EVENT_MESSAGE_VI);
          } else {
            notify('error', 'Message', NOT_CHECKED_IN_EVENT_MESSAGE_JP_EN);
          }
        } else {
          if (state.lang === LANG_CODE_VIETNAMESE) {
            notify('error', 'Message', NOT_EXIST_COMPANY_MESSAGE_VI);
          } else {
            notify('error', 'Message', NOT_EXIST_COMPANY_MESSAGE_JP_EN);
          }
        }

        return '';
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
      return '';
    }
  },

  applyOrCancelInterview: async (
    { commit, state },
    { exhibiting_company_id, interview_schedule_id, interview_status }
  ) => {
    try {
      const res = await http(state).post(
        `${url.CANDIDATE_APPLY_OR_CANCEL_INTERVIEW}`,
        {
          exhibiting_company_id,
          interview_schedule_id,
          interview_status
        }
      );
      if (res.data.status === STATUS_CODE_SUCCESS) {
        notify('success', 'Message', res.data.message);
        commit(APPLICANT_COMPANY_INTERVIEW, { data: res.data.data });
      } else {
        notify('error', 'Message', res.data.message);
        commit(APPLICANT_COMPANY_INTERVIEW, { data: res.data.data });
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  applicantInterviewStatus: async ({ commit, state }) => {
    try {
      const res = await http(state).post(
        `${url.CANDIDATE_APPLICANT_INTERVIEW_STATUS}`
      );
      if (res.data.status === STATUS_CODE_SUCCESS) {
        commit(APPLICANT_INTERVIEW_STATUS, { data: res.data.data });
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  sortApplicantInterviewStatus: async ({ commit, state }, { sort_type }) => {
    try {
      const res = await http(state).post(
        `${url.CANDIDATE_SORT_APPLICANT_INTERVIEW_STATUS}`,
        {
          sort_type
        }
      );
      if (res.data.status === STATUS_CODE_SUCCESS) {
        commit(APPLICANT_INTERVIEW_STATUS, { data: res.data.data });
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  getEventInterviewNote: async ({ commit, state }) => {
    try {
      const res = await http(state).get(`/candidate/get-event-interview-note`);
      if (res.data.status === STATUS_CODE_SUCCESS) {
        commit(EVENT_INTERVIEW_NOTE, { data: res.data.data });
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  clearRegisterData: async ({ commit }) => {
    commit(CLEAR_REGISTER_DATA);
  },

  // testGoogleAnalytic: async ({ commit }) => {
  //   commit(CLEAR_REGISTER_DATA);
  // },

  routerConfig: async ({ dispatch }) => {
    const { eventID, contractID } = router.currentRoute.params;
    const { event_day_register_url_code } = router.currentRoute.query;
    // const { endPointName } = router.currentRoute.meta;

    // if (
    //   endPointName &&
    //   (endPointName === ENTRY_ENDPOINT_NAME ||
    //     endPointName === RECEPTIONIST_ENDPOINT_NAME)
    // ) {
    const data = {
      event_code: eventID,
      contract_id: contractID,
      event_day_register_url_code:
        typeof event_day_register_url_code !== 'undefined'
          ? event_day_register_url_code
          : null
    };

    const fullPath = router.currentRoute;

    await dispatch('getEventMaster', { data, fullPath });
    // }
  },

  initInformation: async ({ dispatch }) => {
    const protocol = window.location.protocol;
    const host = window.location.host;

    const dataDomain = {
      host: host,
      protocol: protocol
    };

    await dispatch('setDomain', { data: dataDomain });
    await dispatch('getConstants');
    await dispatch('routerConfig');
  },

  loginReceptionist: async ({ commit, state }, { data }) => {
    try {
      const res = await http(state, false).post(`${url.RECEPTION_LOGIN}`, data);
      if (res.data.status === STATUS_CODE_SUCCESS) {
        notify('success', 'Message', res.data.message);
        await commit(LOGIN_SUCCESS_RECEPTIONIST, {
          token: res.data.token,
          profile: res.data.profile
        });
        return true;
      } else {
        notify('error', 'Message', res.data.message);
        await commit(LOGIN_ERROR_RECEPTIONIST);
        return false;
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED_RECEPTIONIST, { err });
    }
  },

  landingPageLink: async ({ commit, state }, data) => {
    try {
      const res = await http(state, false).post(
        `${url.LANDING_PAGE_LINK}`,
        data
      );
      if (res.data.status === STATUS_CODE_SUCCESS) {
        await commit(LANDING_PAGE_LINK_SUCCESS, {
          data: res.data.data
        });
        return !!res.data.data.isLandingPage;
      } else {
        await commit(LOGIN_ERROR_RECEPTIONIST);
        return false;
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED_RECEPTIONIST, { err });
    }
  },

  logoutReceptionist: async ({ commit }) => {
    await commit(LOGOUT_RECEPTIONIST);

    notify('success', 'Message', 'Logout successfully');
  },

  setTokenStatusForReceptionist: async ({ commit }) => {
    commit(SET_TOKEN_FOR_RECEPTIONIST);
  },

  // meReceptionist: async ({ commit, state }) => {
  //   try {
  //     const res = await http(state).post(`${url.RECEPTIONIST_ME}`);
  //     if (res.data.status === STATUS_CODE_SUCCESS) {
  //       commit(ME_SUCCESS_RECEPTIONIST, { data: res.data.data });
  //     } else {
  //       commit(ME_ERROR_RECEPTIONIST);
  //     }
  //   } catch (err) {
  //     commit(CHECK_UNAUTHORIZED_RECEPTIONIST, { err });
  //   }
  // },

  receptionCheckInApplicant: async ({ commit, state }, data) => {
    try {
      const res = await http(state, true, 'reception').post(
        `${url.RECEPTION_CHECK_IN}`,
        data
      );
      if (res.data.status === STATUS_CODE_SUCCESS) {
        if (state.lang === LANG_CODE_VIETNAMESE) {
          notify('success', 'Message', CHECKIN_SUCCESS_MESSAGE_VI);
        } else {
          notify('success', 'Message', CHECKIN_SUCCESS_MESSAGE_JP_EN);
        }
        await commit(CHECK_IN_SUCCESS, { data: res.data.data });
      } else {
        switch (res.data.message) {
          case CHECKED_IN: {
            if (state.lang === LANG_CODE_VIETNAMESE) {
              notify('error', 'Message', CHECKED_IN_RECEPTIONIST_MESSAGE_VI);
            } else {
              notify('error', 'Message', CHECKED_IN_RECEPTIONIST_MESSAGE_JP_EN);
            }
            break;
          }
          case INVALID_CHECK_IN: {
            if (state.lang === LANG_CODE_VIETNAMESE) {
              notify('error', 'Message', NOT_EXIST_RECEPTIONIST_MESSAGE_VI);
            } else {
              notify('error', 'Message', NOT_EXIST_RECEPTIONIST_MESSAGE_JP_EN);
            }
            break;
          }
          case TIME_ERROR_CHECK_IN: {
            if (state.lang === LANG_CODE_VIETNAMESE) {
              notify('error', 'Message', TIME_ERROR_CHECK_IN_MESSAGE_VN);
            } else {
              notify('error', 'Message', TIME_ERROR_CHECK_IN_MESSAGE_JP_EN);
            }
            break;
          }
        }
        await commit(CHECK_IN_ERROR);
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED_RECEPTIONIST, { err });
    }
  },

  listReceptionCheckInApplicant: async ({ commit, state }, data) => {
    try {
      const res = await http(state, true, 'reception').post(
        `${url.RECEPTION_LIST_CHECK_IN}`,
        data
      );
      if (res.data.status === STATUS_CODE_SUCCESS) {
        await commit(LIST_CHECK_IN_SUCCESS, { data: res.data.data });
      } else {
        await commit(LIST_CHECK_IN_ERROR);
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED_RECEPTIONIST, { err });
    }
  },

  setContractAndEvent: async ({ commit, state }, { contractID, eventID }) => {
    commit(SET_CONTRACT_EVENT, {
      contract_id: contractID,
      event_code: eventID
    });
  },

  sendInquiry: async ({ commit, state }, data) => {
    try {
      const res = await http(state).post(`${url.SEND_QUESTION_EVENT}`, data);
      if (res.data.status === STATUS_CODE_SUCCESS) {
        notify('success', 'Message', res.data.message);
      } else {
        notify('error', 'Message', res.data.message);
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },

  clearCheckInData: async ({ commit }) => {
    commit(CLEAR_CHECK_IN_DATA);
  },

  setRegistrationPeriodStatus: async ({ commit }, status) => {
    commit(SET_REGISTRATION_PERIOD_STATUS, { status });
  },

  getDataEventSchedule: async ({ commit, state }, data) => {
    try {
      const res = await http(state, true).post(
        `${url.LANDING_PAGE_EVENT}`,
        data
      );

      if (res.data.status === STATUS_CODE_SUCCESS) {
        const data = {
          ...res.data
        };
        commit(GET_DATA_EVENT_SCHEDULE_SUCCESS, data);
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },
  getDataEventSchedulePreview: async ({ commit, state }, data) => {
    try {
      const res = await http(state, true).post(
        `${url.LANDING_PAGE_EVENT}`,
        data
      );

      if (res.data.status === STATUS_CODE_SUCCESS) {
        const data = {
          ...res.data
        };
        commit(GET_DATA_EVENT_SCHEDULE_SUCCESS, data);
        return true;
      } else {
        return false;
      }
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },
  getEventScheduleByDateAndRoom: async ({ commit, state }, data) => {
    try {
      const res = await http(state, true).post(
        `${url.LANDING_PAGE_GET_SCHEDULE}`,
        data
      );

      if (res.data.status === STATUS_CODE_SUCCESS) {
        const dataSchedule = res.data.data.eventSchedule;
        commit(SET_EVENT_SCHEDULE_SUCCESS, { data: dataSchedule });
        return {
          roomId: data.event_schedule_room_id,
          dateId: data.event_schedule_date_id
        };
      }

      return {
        roomId: data.event_schedule_room_id,
        dateId: data.event_schedule_date_id
      };
    } catch (err) {
      commit(CHECK_UNAUTHORIZED, { err });
    }
  },
  getEventMasterWhenClickMenu: async ({ commit, state }, { data }) => {
    try {
      const res = await http(state, false).post(`${url.EVENT_MASTER}`, data);
      if (res.data.status === STATUS_CODE_SUCCESS) {
        await commit(GET_EVENT_MASTER, {
          data: res.data.data,
          registrationPeriodStatus: res.data.registrationPeriodStatus
        });
      }
    } catch (err) {
      await commit(EVENT_ERROR);
      commit(CHECK_UNAUTHORIZED, { err });
    }
  }
};
export default actions;
